module.exports = __webpack_public_path__ + "static/media/compiled.5c9d9da2.mov";